import { render } from "./ProductFormularImage.vue?vue&type=template&id=7ba85ef4"
import script from "./ProductFormularImage.vue?vue&type=script&lang=js"
export * from "./ProductFormularImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__